// extracted by mini-css-extract-plugin
export var actionButton = "_ek-t";
export var buttonContainer = "_ek-0";
export var buttonContainer2 = "_ek-1";
export var buttonSection = "_ek-2";
export var details = "_ek-3";
export var dropdownItem = "_ek-5";
export var dropdownItemsContainer = "_ek-4";
export var fileInput = "_ek-r";
export var headerButton = "_ek-6";
export var icon = "_ek-7";
export var input = "_ek-8";
export var macroListItem = "_ek-9";
export var mainContent = "_ek-a";
export var microText = "_ek-b";
export var modal = "_ek-w";
export var optionsButton = "_ek-c";
export var paperclip = "_ek-s";
export var pillContent = "_ek-d";
export var preview = "_ek-e";
export var preview2 = "_ek-f";
export var quillEditor = "_ek-q";
export var selectedMacro = "_ek-g";
export var sidebar = "_ek-h";
export var sidebarHeader = "_ek-j";
export var sidebarList = "_ek-i";
export var sidebarListItem = "_ek-k";
export var sidebarSearch = "_ek-l";
export var snoozeDurationWrapper = "_ek-v";
export var statusPillContainer = "_ek-m";
export var tagsContainer = "_ek-n";
export var unselectedMacro = "_ek-o";
export var variable = "_ek-u";
export var wrapper = "_ek-p";